import React from "react";
import {
  View,
  Text,
  Image,
  Dimensions,
  Animated,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  FlatList,
  TextInput,
} from "react-native";
import Header from "../../component/header";
import Background from "../../component/background";
import TabbarOption from "../../component/tabbarOption";

import FlatlistAthlete from "../../component/flatlistAthlete";
import { apiservice } from "../../service";
import { useRecoilValue } from "recoil";
import { tokenState } from "../../reducer/recoil";
const { width, height } = Dimensions.get("window");
export default function index({ navigation }) {
  const [text, setText] = React.useState("");
  const [fil, setFil] = React.useState("");
  const [gender, setGender] = React.useState("");
  const [country, setCountry] = React.useState([]);
  const token = useRecoilValue(tokenState);

  async function callAll() {
    const response = await apiservice({
      path: "/competitions/opt/components",
      method: "get",
      token: token.token,
    });
    if (response.status == 200) {
      setCountry(
        response.data.getCountriesComponent.map((item) => {
          return { label: item.country_name, value: item.country_name };
        })
      );
    }
  }

  React.useEffect(() => {
    callAll();
  }, []);

  return (
    <View style={styles.container}>
      <Header
        onPressHome={() => {
          navigation.navigate("HomeUser");
        }}
        onPressCompetition={() => {
          navigation.navigate("CompetitionUser");
        }}
        onPressAthlete={() => {
          navigation.navigate("AthleteUser");
        }}
        onPressLogout={() => {
          navigation.navigate("Login");
        }}
        backgroundColorAthlete="#FFFFFF"
        User
        navigation={navigation}
      />
      <ScrollView>
        <View>
          <Background navigation={navigation} Title="ATHLETE" />
          {
            <TabbarOption
              country={country}
              onfilter={(val) => {
                if (val != "Countries") {
                  setFil(val);
                } else {
                  setFil("");
                }
              }}
              setGender={(val) => {
                if (val != "GENDER") {
                  setGender(val);
                } else {
                  setGender("");
                }
              }}
              Athlete
              AthleteUser
              buttonTabbar
              onChangeText={(text) => {
                setText(text);
              }}
            />
          }
          <FlatlistAthlete gender={gender} text={text} fil={fil} />
        </View>
      </ScrollView>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#CCE4FF",
    flexDirection: "row",
  },
});
